import { render, staticRenderFns } from "./WCambiarEvento.vue?vue&type=template&id=4e270f83&"
import script from "./WCambiarEvento.vue?vue&type=script&lang=js&"
export * from "./WCambiarEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WLoading from '@/components/WLoading.vue'
autoInstallComponents(component, {WLoading})
